//      
             
                     
             
              
             
                  
import { origin } from './position';

export const noDisplacedBy              = {
  point: origin,
  value: 0,
};

export const emptyGroups                     = {
  invisible: {},
  visible: {},
  all: [],
};

const noImpact             = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null,
};

export default noImpact;

export const noAfterCritical             = {
  inVirtualList: false,
  effected: {},
  displacedBy: noDisplacedBy,
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/no-impact.js